import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoDRPViewComponent } from './pedido-drp-view.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoDRPViewComponent
    ],
    exports: [
        PedidoDRPViewComponent
    ]
})
export class PedidoDRPViewModule { }
